import TextVideo from '../components/TextVideo';
import CustomAccordion from '../components/CustomAccordio';
import CardBox from '../components/CardBox';
import langData from '../locales/langData.json';
import VideoSlider from '../components/VideoSlider';
import { GoArrowRight } from 'react-icons/go';
import circle from '../assets/images/cen-circle-icon.svg'
import circleone from '../assets/images/g1.webp'
import circletwo from '../assets/images/g2.webp'
import circlethree from '../assets/images/g3.webp'
import arrow from '../assets/images/right-arrow.webp'
import { LiaArrowRightSolid } from 'react-icons/lia';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import SEO from '../components/SEO';


const Home = ({ language }) => {
  const text = langData[language].home;
  const company = langData[language].home.company;
  const newsCard = langData[language].home.newsCard;
  const videoSlider = langData[language].home.videoSlider;
  const cta = langData[language].home.cta;
  const transform = langData[language].home.transform;
  const members = langData[language].home.members;
  const [visibleCards, setVisibleCards] = useState(newsCard.news);


  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      // 👇 Show only 2 cards for 768px–1024px range
      if (width >= 768 && width <= 1024) {
        setVisibleCards(newsCard.news.slice(0, 2));
      } else {
        setVisibleCards(newsCard.news);
      }
    };

    handleResize(); // Run on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [newsCard.news]);


  // const navigate = useNavigate();

  return (
    <>
      <SEO
        title="CaptainX | AI-Powered Sports Technology Company"
        titleAr="كابتن اكس | شركة تكنولوجيا رياضية مدعومة بالذكاء الاصطناعي"
        description="Building the future in every athlete through an AI-powered sports ecosystem that unites athletes, academies, federations, and clubs to achieve greatness."
        descriptionAr="بناء المستقبل لكل رياضي من خلال نظام بيئي رياضي مدعوم بالذكاء الاصطناعي يوحد الرياضيين والأكاديميات والاتحادات والأندية."
        path="/"
        language={language}
      />
      {/* <Hero/> */}
      <div className='hero-section'>
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-7 hero-btn">
              <div className="hero-sec-con">
                <h2
                  className='sec-title hero-tit block-view'
                  dangerouslySetInnerHTML={{ __html: text.heroTitle }}
                />
                <p className='block-view sec-p '>{text.heroDesc}</p>
                <div className="mob-btn">

                  <Link to="/#discover" className="explore-btn space-btn hero-btn">
                    {text.exploreBtn}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-5"></div>
          </div>
        </div>
        <div className="container_mouse scroll-down d-none d-md-block">
          <span className="mouse-btn">
            <span className="mouse-scroll"></span>
          </span>
          <span>{text.scrollDown}</span>
        </div>
      </div>


      <TextVideo language={language} />


      <section className='why-sec' >
        <CustomAccordion language={language} />
      </section>

      <section className='py-4 solution'>
        <center>
          <h2 className='sec-title block-view' dangerouslySetInnerHTML={{ __html: text.solutionTitle }} />
        </center>
        <div className="card-box block-view">
          <CardBox language={language} />
        </div>
      </section>



      <section className='slider-sec'>
        <center>
          <h6 className='sec-top-titl block-view'>{videoSlider.topTitle}</h6>
          <h2 className='sec-title block-view' >{videoSlider.title}</h2>
        </center>

        <VideoSlider language={language} />
        {/* <GoogleStyleSlider/> */}
      </section>

      <section className='py-5 company-section'>
        <div className="container">
          <div className="row justify-content-center align-items-center"> 
            <div className="col-md-6 py-5">
              <h6 className="sec-top-titl block-view">{company.keyValueTop}</h6>
              <h2
                className="sec-title block-view"
                dangerouslySetInnerHTML={{ __html: company.keyValueTitle }}
              />
              <p className="sec-p block-view">{company.keyValueDesc}</p>

              <Link className="view-all" to="/company">
                {company.learnmore} <LiaArrowRightSolid /> 
              </Link>
            </div>
            <div className="col-md-6 pb-5">
              <LazyLoadImage src={company.image} alt="company" className='img-fluid' />
            </div>
          </div>
        </div>
      </section>


      <section className='transforming py-4'>
        <div className="container">
          <center>

            <div className="cen-sec-con">

              <h2 className='sec-title trans-test-h text-white
               block-view' dangerouslySetInnerHTML={{ __html: transform.title }}></h2>
              <Link to="/partners" className='under-line'>
                <button className='bg-white-btn my-4 transform-btn '>

                  {transform.btn}
                </button>
              </Link>
            </div>

            <div className="circle-group mt-4">
              {/* Rotating outer circle background only */}
              <div className="circle circle-1"></div>

              {members.map((member, i) => {
                const angle = i * 90; // adjust spacing
                const isThird = i === 2; // check 3rd member
                return (
                  <div
                    key={i}
                    className="member"
                    style={{
                      transform: `rotate(${angle}deg) translate(var(--translate-distance)) rotate(-${angle}deg)`
                    }}
                  >

                    <LazyLoadImage src={member.img} alt={member.name} className='member-img' />
                    <span className={`name-tag d-none d-md-block  ${isThird ? "name-tag-right" : ""}`}>
                      {member.name} <br /> {member.design}
                    </span>
                  </div>
                );
              })}


              {/* Middle & inner circles */}
              <div className="circle circle-1">
                <img src={circleone} alt="circle" />
              </div>
              <div className="circle circle-2">
                <img src={circletwo} alt="circle" />
              </div>
              <div className="circle circle-3">
                <img src={circlethree} alt="circle" />
              </div>
              <div className="circle circle-4">
                <img src={circleone} alt="circle" />
              </div>
              {/* <div className="circle circle-5"></div> */}

              {/* Center text */}
              <div className="circle-center-text">
                <LazyLoadImage src={circle} alt="circle" />
                {/* <p>{transform.centerText}</p> */}
              </div>
            </div>

          </center>

        </div>
      </section>

      <section className='news'>
        <div className="container">
          <div className="row">

            <div className="col-md-6 news-top-texts">
              <h6 className="sec-top-titl block-view">{newsCard.topTitle}</h6>
              <h2
                className="sec-title block-view"
                dangerouslySetInnerHTML={{ __html: newsCard.title }}
              />
            </div>
            <div className="col-md-6"></div>
          </div>

          <div className="row">
            {visibleCards.map((item, index) =>

              <div className="col-md-6 col-lg-4 mb-4" key={index}>
                <div className="company-boxs">
                  <div className="comp-box">
                    <div className=" " >
                      <div className="arrow-box"></div>
                      <div
                        className={`news-cards ${language === 'ar' ? 'rtl' : 'ltr'}`}
                      >
                        <h3>{item.number}</h3>
                        <h2>{item.title}</h2>
                        <p>{item.desc}</p>
                      </div>

                      <span className={`date ${language === 'ar' ? 'rtl-date' : 'ltr-date'}`}>{item.date}</span>
                    </div>
                  </div>
                  <div className="bottom-box-arr">
                    <LazyLoadImage src={arrow} alt="arrow" className='' />
                  </div>

                </div>
              </div>
            )}
          </div>
          <Link className="view-all view-all-right my-2" to="/news">
            {newsCard.viewall}<GoArrowRight />
          </Link>
        </div>

      </section>

      <section className='cta cta-home'>
        <div className="container">
          <div className="cen-sec-con">

            <center>
              <h2 className='sec-title ' dangerouslySetInnerHTML={{ __html: cta.title }}></h2>
              <p className="sec-p" dangerouslySetInnerHTML={{ __html: cta.desc }}></p>
              <Link to='/contact' className='under-line'>
                <button
                  className={`explore-btn cta-btn mb-5 gap-3  ${language === "ar" ? "ar-padding" : "en-padding"
                    }`}
                >{cta.ctaButton}

                  <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                </button>
              </Link>
            </center>

          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
